<script setup lang="ts">
import JournalCard from '@/entities/journal/ui/JournalCard.vue';

import type { IJournalArticle } from '@/entities/journal/model/types';

withDefaults(
  defineProps<{
    similarArticles: IJournalArticle[];
    journalDetailLink?: string;
  }>(),
  {
    journalDetailLink: '',
  },
);

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['similar-articles', { _mobile: isMobile }]">
    <div class="similar-articles__header">
      <h3 class="similar-articles__title">
        <NuxtLink class="similar-articles__link" :to="journalDetailLink">
          Похожие статьи
          <AppIcon name="ArrowRightJournal" class="similar-articles__icon" />
        </NuxtLink>
      </h3>
    </div>
    <ul class="similar-articles__list">
      <li
        v-for="card in similarArticles"
        :key="card.id"
        class="similar-articles__list-item"
      >
        <JournalCard :card="card" />
      </li>
    </ul>
  </div>
</template>

<style lang="less">
.similar-articles {
  .flex-column(@size-x6);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: @size-x3;
  }

  &__list {
    display: grid;
    gap: @size-x5;
    grid-template-columns: repeat(auto-fill, minmax(23%, 1fr));
  }

  &__title {
    .h-offset-reset();
  }

  &__link {
    .color-change-hover();

    display: inline-flex;
    align-items: center;
    gap: @size-x3;
    font-size: @size-x6;
    line-height: 31px;
    font-weight: 700;
    word-break: break-word;
  }

  &__icon {
    path {
      fill: @color-persimmon;
    }
  }

  &._mobile &__list {
    .horizontal-scroll-snap();

    border-bottom: 0;
  }
}
</style>
